import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * Back button shown at the top-left of every inner page.
 * Hidden on the small set of top-level routes (which already have a tab-bar/home link).
 */
const TOP_LEVEL = new Set([
  "/", "/projects", "/operations", "/programme", "/reports",
  "/configuration", "/my/timesheets", "/more", "/worker/more",
]);

export default function BackButton() {
  const nav = useNavigate();
  const loc = useLocation();
  // Normalise trailing slash — "/projects/" counts as "/projects"
  const path = loc.pathname.replace(/\/+$/, "") || "/";
  if (TOP_LEVEL.has(path)) return null;

  function goBack() {
    // Prefer the browser history. If the user landed here via a deep link
    // (no prior history on the SPA), fall back to a sensible parent route.
    if (window.history.length > 1) {
      nav(-1);
      return;
    }
    const parts = path.split("/").filter(Boolean);
    const parent = parts.length > 1 ? "/" + parts.slice(0, -1).join("/") : "/";
    nav(parent);
  }

  return (
    <button
      type="button"
      onClick={goBack}
      data-testid="btn-back"
      aria-label="Back"
      className="inline-flex items-center gap-1 text-silver hover:text-white text-sm mb-3 px-2 py-1 rounded border border-neutral-800 hover:border-silver bg-black/40"
    >
      <ChevronLeft size={16}/><span>Back</span>
    </button>
  );
}
